import React from 'react';
import Header from './components/header/Header';
import MyProjects from './components/myProjects/MyProjects';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <MyProjects />
    </div>
  );
}

export default App;
